<template>
    <div class="tq-capsule-tabs">
        <tq-button 
            v-for="(item, index) in buttonTabs" 
            :key="item.id" :type="item.active ? 'primary' : ''" 
            @click="changeActive(index)"
            round>
            {{ item.name }}
        </tq-button>
    </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['onChange'])
defineOptions({
  name: 'TqCapsuleTabs'
})
type tabsType = {
    id: number,
    name: string,
    active: boolean
};

const props = defineProps({
    buttonTabs: {
        type: Array<tabsType>,
        default: () => []
    }
});
const changeActive = (index: number) => {
    props.buttonTabs.forEach((item, i) => {
        item.active = i === index;
    });
    emit('onChange');
}

</script>